"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _LotDetail = _interopRequireDefault(require("./components/LotDetail"));

var _AffaireTotaux = _interopRequireDefault(require("./components/AffaireTotaux"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

require("@/mixins/workflow");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'BudgetComp',
  components: {
    LotDetail: _LotDetail.default,
    AffaireTotaux: _AffaireTotaux.default
  },
  data: function data() {
    return {
      // pour rafraichir l'affichage apres ajout/modification/suppression d'un lot
      refresh: 0,
      // pour filtrer les budgets complémentaires jusqu'à une date
      // dateMax: null,
      // mode saisie des montants
      modeEdit: false,
      // constantes
      CONST: CONST,
      //
      userCanDoAction: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    },
    dateFormat: function dateFormat() {
      return this.user.date_format; // dd/MM/yyyy
    },
    nbLotsDetail: function nbLotsDetail() {
      var nb = this.affaire.lotsDetail.filter(function (x) {
        return x.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.BUDGET_COMP;
      });
      return nb.length;
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWorkflow('gestion_mensuelle').then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(_this.affaire.affaire.etape, 'gestion_mensuelle') || false;
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  mounted: function mounted() {
    _eventBus.EventBus.$emit('REFRESH_CALCULS');
  },
  methods: {
    canEdit: function canEdit() {
      // edition possible uniquement si on est sur la période de gestion courante.
      return this.affaire.YYYYMM === this.affaire.currentGestMensYYYYMM;
    },

    /*
    handleChangeDate (date) {
      this.dateMax = date
      EventBus.$emit('REFRESH_CALCULS', { date_max: this.dateMax })
    },
    */
    handleNewBudgetComp: function handleNewBudgetComp() {
      this.modeEdit = true;

      _eventBus.EventBus.$emit('BUDGETCOMP_NEW');

      _eventBus.EventBus.$emit('MODE_EDIT', true);
    },
    handleCancelBudgetComp: function handleCancelBudgetComp() {
      this.modeEdit = false;

      _eventBus.EventBus.$emit('BUDGETCOMP_CANCEL');

      _eventBus.EventBus.$emit('MODE_EDIT', false);
    },
    handleSaveBudgetComp: function handleSaveBudgetComp() {
      this.modeEdit = false;

      _eventBus.EventBus.$emit('BUDGETCOMP_SAVE');

      _eventBus.EventBus.$emit('MODE_EDIT', false);

      this.$store.dispatch('affaire/setHistorique', _objectSpread({}, this.affaire.affaire, {
        message: 'Nouveau budget complémentaire n° ' + Number(this.affaire.nbColBudgetComp + 1)
      }));
      this.refresh++;
    }
  }
};
exports.default = _default;